export default class PredictiveSearch {
  constructor(theme, element) {
    this.theme = theme;
    this.element = element;

    this.searchElementType = 'section';

    if (this.element.dataset.wethemeSectionType == 'header') {
      this.searchElementType = 'header';
    }

    this.searchForm = this.element.querySelector('#search-page-form, #search-page-form-header');
    this.searchWrapperID = '#top-search-wrapper';
    if(this.searchElementType == 'section') {
      this.searchWrapperID = '#block-search-wrapper';
    }
    this.searchWrapper = this.element.querySelector(this.searchWrapperID);
    this.searchIcons = this.element.querySelectorAll('.search-show');
    this.searchClear = this.element.querySelectorAll('.search-clear');
    this.searchInput = this.element.querySelector('#search_text, #search_text_search_block');
    this.searchSubmitBtn = this.element.querySelector('#search_submit, #search_submit_search_block');
    this.searchClearBtn = this.element.querySelector('#search-bar--clear, #search-bar-search-block--clear');
    this.searchCloseModalBtn = this.element.querySelector('#search-bar--close');
    this.loadingIcon = this.element.querySelector('.predictive-loading');
    this.searchSummary = this.element.querySelector('.search-summary');
    this.isPredictiveSearch = this.element.querySelector('[data-predictive-search]');
    this.searchResultsPanel = this.element.querySelector(
      '.search-results-panel'
    );
    this.expandedSearch = document.querySelector('.header-search--expanded');
    this.searchResultsStatus = this.element.querySelector('.search-status');
    this.searchChangeTimer = null;
    this.searchToggler = null;
    this.lastFocus = document.activeElement;
    this.searchResultsNum = 0;
    this.searchHasResults = false;

    this.isSearchPredictive = false;
    this.showPrices = false;
    this.showVendor = false;
    this.initialLoad = true;

    if (this.searchInput) {
      this.isSearchPredictive = this.searchInput.classList.contains(
        'is-predictive'
      );
      this.showPrices = this.searchInput.dataset.showPrices == 'true';
      this.showVendor = this.searchInput.dataset.showVendor == 'true';
      this.loadSearch();
    }
  }

  loadSearch = () => {
    const self = this;
    let closeFunc = this.searchClose;

    if (this.searchElementType === 'section' && this.isPredictiveSearch) {
      closeFunc = this.clearResultsClose;

      document.addEventListener('click', function(e) {
        const target = /** @type {HTMLElement} */ (e.target);
        if (!target) return;

        // If click NOT in search section results, hide results panel.
        if (!self.searchWrapper.contains(target) && !self.searchResultsPanel.contains(target)) {
          self.hideResults();
        }
        else if(target === self.searchInput && self.searchInput.value > '') {
          self.searchOpen();
        }
      });

      this.searchInput.addEventListener('keyup', function(e) {
        if(self.searchInput.value > '' && e.code !== 'Tab') {
          self.searchOpen();
        }
      });
    }

    for (const clear of this.searchClear) {
      clear.addEventListener('click', closeFunc);
      clear.addEventListener('keyup', function(e) {
        if (e.code === 'Enter') {
          self.closeFunc();
        }
      });
    }

    for (const icon of this.searchIcons) {
      icon.addEventListener('click', this.searchOpen);
    }

    if (this.expandedSearch) {
      this.allowFocus();
    }

    this.element.setAttribute('data-num-groups', this.searchTypesNum);
    this.searchForm.addEventListener('submit', this.searchSubmit);
    document.addEventListener('click', this.backgroundSearchClose);
    this.searchInput.addEventListener('keyup', this.searchChanged);

    document.addEventListener('click', function(e) {
      const target = /** @type {HTMLElement} */ (e.target);
      if (!target) return;
    });

    if (this.searchElementType === 'header') {
      this.searchInput.addEventListener('click', this.showResults);
      this.searchInput.addEventListener('focus', this.showResults);
    }

    if (this.searchCloseModalBtn) {
      this.searchCloseModalBtn.addEventListener('click', this.closeSearchModal);
    }
  };

  allowFocus = () => {
    this.searchInput.setAttribute('tabindex', '0');
    this.searchSubmitBtn.setAttribute('tabindex', '0');
    this.searchClearBtn.setAttribute('tabindex', '0');

    this.searchWrapper.setAttribute('aria-hidden', 'false');
    this.searchInput.setAttribute('aria-hidden', 'false');
    this.searchSubmitBtn.setAttribute('aria-hidden', 'false');
    this.searchClearBtn.setAttribute('aria-hidden', 'false');

    if (this.searchCloseModalBtn) {
      this.searchCloseModalBtn.setAttribute('tabindex', '0');
      this.searchCloseModalBtn.setAttribute('aria-hidden', 'false');
    }
  }

  hideResults = () => {
    // Hide results if predictive search is enabled
    if(this.isPredictiveSearch) {
      this.searchResultsPanel.classList.add('hide');
    }
  }

  showResults = () => {
    // Show results if predictive search is enabled
    if(this.isPredictiveSearch) {
      this.searchResultsPanel.classList.remove('hide');
    }
  }

  clearResultsClose = () => {
    this.searchResultsNum = 0;
    this.searchHasResults = false;
    this.searchResultsPanel.innerHTML = '';
    this.searchWrapper.classList.remove('has-results');
    this.searchInput.value = '';
    this.searchInput.focus();
  };

  searchSubmit = (e) => {
    // Search has been submitted, by a keypress or clicking the icon.
    // We need to send the search term so that the search page's
    // results match the predictive results. E.g. appending '*' so
    // the search page does a 'starts with' search.
    e.preventDefault();
    window.location.href = this.getSearchPageUrlWithQuery();
  };

  searchOpen = (e) => {
    if(e) e.preventDefault();

    if(this.searchElementType === 'header') {
      this.lockScrolling();
      this.searchToggler = e.target.closest('.search-show');
      this.searchToggler.setAttribute('aria-expanded', 'true');
      this.allowFocus();

      this.searchInput.setAttribute('aria-hidden', 'false');
      this.searchSubmitBtn.setAttribute('aria-hidden', 'false');
      this.searchClearBtn.setAttribute('aria-hidden', 'false');
    }

    this.showResults();
    this.searchInput.setAttribute('tabindex', '0');
    this.searchSubmitBtn.setAttribute('tabindex', '0');
    this.searchClearBtn.setAttribute('tabindex', '0');

    this.searchWrapper.classList.add('expanded');
    this.moveCursorToEnd(this.searchInput);
    this.lastFocus = document.activeElement;

    setTimeout(this.trapFocus, 500);
    return false;
  };

  searchClose = (e) => {
    if (this.searchElementType === 'header') {
      this.clearResultsClose();
      this.searchInput.setAttribute('tabindex', '-1');
      this.searchInput.setAttribute('aria-hidden', 'true');
      this.searchSubmitBtn.setAttribute('aria-hidden', 'true');
      this.searchClearBtn.setAttribute('aria-hidden', 'true');

      if (this.searchToggler) {
        this.searchToggler.setAttribute('aria-expanded', 'false');
      }
    }

    if (this.expandedSearch) {
      this.allowFocus();
    }

    this.searchInput.blur();
    this.lastFocus.focus();

    return false;
  };

  closeSearchModal = () => {
    // Close modal and hide results panel but retain query
    this.hideResults();
    this.unlockScrolling();
    this.searchWrapper.classList.remove('expanded');
  }

  handleLastInputKeydown = (e) => {
    // Redirect last tab to first input
    if (e.code === 'Tab' && !e.shiftKey) {
      e.preventDefault();
      this.firstInput.focus();
    }
  };

  handleFirstInputKeydown = (e) => {
    // Redirect first input shift+tab to last input
    if (e.code === 'Tab' && e.shiftKey) {
      e.preventDefault();
      this.lastInput.focus();
    }
  };

  resetCloseBtnKeydown = (e, nextElement) => {
    if (e.code === 'Tab' && !e.shiftKey) {
      nextElement.focus();
    }
  };

  trapFocus = () => {
    let focusWithinElem;

    if (this.searchElementType === 'header') {
      focusWithinElem = this.searchWrapper;
    }
    else {
      focusWithinElem = this.element.closest('#section-search-wrapper');
    }

    const inputs = focusWithinElem.querySelectorAll(
      `input:not([type=hidden]), button:not([tabindex="-1"]), a:not([tabindex="-1"]), .search-clear`
    );

    const inputsArr = Array.from(inputs);
    const closeBtn = this.searchElementType === 'header' ? ['search-bar--close'] : ['search-bar-search-block--clear'];

    const closeBtnIndex = inputsArr.indexOf(
      inputsArr.find((el) => el.id == closeBtn[0] || el.id == closeBtn[1])
    );

    this.firstInput = inputs[0];
    this.lastInput = inputs[inputs.length - 1];
    const self = this;

    // If search box is there, focus on input
    if (this.element.querySelector(this.searchWrapperID) && this.initialLoad) {
      this.element.querySelector('#search_text, #search_text_search_block').focus();
    }

    // If the last input is not the close btn then reset the keydown handler
    // n.b. this is a workaround as could not get removeEventListener to work
    /**
     * @todo noticed that perhaps keyup should be removed rather than keydown
     * which might explain why removeEventListener wasn't working
     */
    if (this.lastInput.id != closeBtn) {
      this.element.querySelector(`#${closeBtn}`).addEventListener('keydown', function(e) {
        self.resetCloseBtnKeydown(e, inputs[closeBtnIndex + 1]);
      });
    }

    this.lastInput.addEventListener('keydown', self.handleLastInputKeydown);
    this.firstInput.addEventListener('keydown', self.handleFirstInputKeydown);
    this.initialLoad = false;
  };

  backgroundSearchClose = (e) => {
    const target = /** @type {HTMLElement} */ (e.target);
    if (!target) return;

    if (this.searchElementType === 'section') {
      if (target !== e.currentTarget) return;
      this.searchClose();
      return;
    }

    const collapsedSearchOpen = this.searchWrapper.classList.contains('expanded');
    const expandedSearchOpen = !this.searchWrapper.classList.contains('expanded') && this.searchWrapper.classList.contains('has-results');

    // Clicking search overlay closes search modal and clicking off search wrapper closes expanded search
    if (collapsedSearchOpen && target == this.searchWrapper) {
      this.closeSearchModal();
    } else if (expandedSearchOpen && !this.searchWrapper.contains(target)) {
      this.hideResults();
    }
  };

  moveCursorToEnd = (el) => {
    el.focus();

    if (typeof el.selectionStart == 'number') {
      el.selectionStart = el.selectionEnd = el.value.length;
    } else if (typeof el.createTextRange != 'undefined') {
      var range = el.createTextRange();
      range.collapse(false);
      range.select();
    }
  };

  searchChanged = (e) => {
    const inputText = e.target.value;

    if (this.isSearchPredictive) {

      if (this.searchChangeTimer) {
        window.clearTimeout(this.searchChangeTimer);
      }

      if (inputText.length > 0) {
        this.searchChangeTimer = window.setTimeout(() => {
          this.performSearch();
          this.searchChangeTimer = null;
        }, 250);
      }
      else {
        this.searchResultsNum = 0;
        this.searchHasResults = false;
        this.searchWrapper.classList.remove('has-results');
        this.searchResultsPanel.innerHTML = '';
      }
    }
  };

  hideLoading = () => {
    this.loadingIcon.classList.add('hide');
  };

  showLoading = () => {
    this.displayResults(false);
    this.loadingIcon.classList.remove('hide');
  };

  getSearchQuery = () => {
    return `/search/suggest.json?q=${this.searchInput.value}&resources[limit]=3&resources[limit_scope]=each`;
  };

  getSearchPageUrlWithQuery = () => {
    return `/search?q=${encodeURIComponent(
      this.searchInput.value
    )}*`;
  };

  lockScrolling = () => {
    const scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    if (scrollY > 300) {
      document.body.style.top = `-${scrollY}px`;
    }
    document.documentElement.style.scrollBehavior = 'auto';
  };

  unlockScrolling = () => {
    const scrollY = document.body.style.top;
    document.body.style.position = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    document.documentElement.style.scrollBehavior = '';
  };

  performSearch = async () => {
    this.showLoading();
    this.searchHasResults = false;
    this.searchResultsNum = 0;
    this.searchWrapper.classList.remove('has-results');

    const searchUrlWithQuery = this.getSearchQuery();
    let data;

    try {
      const response = await fetch(searchUrlWithQuery);

      if (!response.ok) {
        console.error('Search failed', response);
        window.location.href = this.getSearchPageUrlWithQuery();
        return;
      }

      data = await response.json();
    } catch (e) {
      console.error('Search failed', e);
      // We'll redirect the user to /search page when ajax search fails.
      window.location.href = this.getSearchPageUrlWithQuery();
    }

    const resultGroups = new Map();

    // Loop over groups e.g. Products / Pages / Articles / Collections
    Object.keys(data.resources.results).forEach((resultType) => {
      let group = resultGroups.get(resultType);
      let result = data.resources.results[resultType];

      if (!group) {
        group = {
          name: {
            articles: this.theme.translations.articles,
            pages: this.theme.translations.pages,
            products: this.theme.translations.products,
            collections: this.theme.translations.collections
          }[resultType],
          results: []
        };
        resultGroups.set(resultType, group);
      }

      // Format price.
      let resultWithPrice = result.map((item) => {
        var temp = Object.assign({}, item);
        if (temp.price) {
          temp.price = this.theme.formatMoney(temp.price);
        }
        return temp;
      });

      group.results = resultWithPrice;

      if (group.results && group.results.length > 0) {
        this.searchResultsNum += result.length;
        this.searchHasResults = true;
      }
    });

    if (!this.searchHasResults && this.searchInput.value > '') {
      // UX: Hide the empty-state drop-down when there are no product suggestions
      // that match the query. The lack of feedback from predictive search should
      // encourage customers to continue their search from the results page.

      // Display 'no results found for XYZ' text.
      // this.searchSummary.innerHTML = this.theme.translations.no_results_html.replace('{{ terms }}', this.searchInput.value);

      // Display no feedback.
      this.searchSummary.innerHTML = '';
    }

    const searchGroups = Array.from(resultGroups.values());
    this.hideLoading();
    this.displayResults(searchGroups, this.trapFocus);
  };

  displayResults = (results, searchTrapFocus) => {
    if (!results || this.searchInput.value == '') {
      this.searchResultsPanel.innerHTML = '';
      this.searchWrapper.classList.remove('has-results');
      return;
    }

    let self = this;
    let resultsHtml = '';
    const soldOut = this.theme.translations.soldOut;
    let searchPageUrlWithQuery = this.getSearchPageUrlWithQuery();
    const resultPluralize =
      this.searchResultsNum == 1
        ? this.theme.translations.search_result
        : this.theme.translations.search_result_plural;
    const noneFound =
      this.searchResultsNum == 0 ? this.theme.translations.none_found : '';

    if (this.searchInput.value > '' || this.searchResultsNum > 0) {
      resultsHtml = resultsHtml.concat(
        `<div class="search-results__meta top">`
      );
    }

    resultsHtml = resultsHtml.concat(`
      <div class="search-results__status ${
        noneFound ? '' : 'sr-only'
      }" role="status">${noneFound} ${resultPluralize} ${
        this.theme.translations.search_found
      }.</div>`);

    if (this.searchInput.value > '' || this.searchResultsNum > 0) {
      resultsHtml = resultsHtml.concat(`</div>`);
    }

    Object.keys(results).forEach(function(groupKey) {
      const group = results[groupKey];
      if(group.name == undefined) {
        group.name = self.theme.translations.suggestions;
      }
      const groupResults = group.results;

      if (groupResults.length > 0) {
        resultsHtml = resultsHtml.concat(
          `<div class="predictive-search-group">`
        );
        resultsHtml = resultsHtml.concat(
          `  <h2 class="type-subheading type-subheading--1">${group.name}</h2>`
        );
        resultsHtml = resultsHtml.concat(
          `  <div class="search--result-group">`
        );

        Object.keys(groupResults).forEach(function(resultKey) {
          const result = groupResults[resultKey];
          let infoColClass = 'col-12';

          resultsHtml = resultsHtml.concat(`<article class="row">`);

          if (result.featured_image && result.featured_image.url > '') {
            resultsHtml = resultsHtml.concat(`<div class="col-3">`);
            resultsHtml = resultsHtml.concat(
              `<a href="${result.url}" tabindex="-1"><img src="${result.featured_image.url}" alt="${result.featured_image.alt}" /></a>`
            );
            resultsHtml = resultsHtml.concat(`</div>`);
            infoColClass = 'col-9';
          }

          resultsHtml = resultsHtml.concat(`<div class="${infoColClass}">`);

          if (self.showVendor && result.vendor) {
            resultsHtml = resultsHtml.concat(
              `<div class="search-vendor">${result.vendor}</div>`
            );
          }

          resultsHtml = resultsHtml.concat(
            ` <h5><a href="${result.url}">${result.title ? result.title : result.styled_text }</a></h5>`
          );

          if (!result.available && group.name == 'Products') {
            resultsHtml = resultsHtml.concat(`<div>${soldOut}</div>`);
          }

          if (self.showPrices && result.price) {
            resultsHtml = resultsHtml.concat(
              ` <div class="search-price">${result.price}</div>`
            );
          }

          resultsHtml = resultsHtml.concat(`</div></article>`);
          resultsHtml = resultsHtml.concat(
            `<span class="search-result-separator"><hr /></span>`
          );
        });

        resultsHtml = resultsHtml.concat(`  </div>`);
        resultsHtml = resultsHtml.concat(`</div>`);
      }
    });

    if (this.searchResultsNum > 0) {
      resultsHtml = resultsHtml.concat(`
        <div class="search-results__meta bottom">
          <div class="search-results__meta-view-all"><a href="${searchPageUrlWithQuery}">${this.theme.translations.view_all}</a></div>
        </div>
      `);
    }

    if (this.searchInput.value > '') {
      this.searchWrapper.classList.add('has-results');
    } else {
      this.searchWrapper.classList.remove('has-results');
    }

    this.searchResultsPanel.innerHTML = resultsHtml;
    searchTrapFocus();
  };
}
